export const environment = {
  production: false,
  API_ENDPOINT: 'https://api.unaflormx.com/v1/',
  API_KEY_MAP: 'AIzaSyDJ8fM_cTF4eVxjMRA89wPb9OmDrfjJsAk'
};
